import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./font/arial/style.css";
import "./font/noto/style.css";
import "./font/poppins/poppins.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./font.css";
import "./App.css";

import Login from "./componets/auth/Login";
import Dashboard from "./pages/Dashboard";
import Category from "./pages/Category";
import User from "./pages/User";
import EntryFormManagement from "./pages/EntryFormManagement";
import AddEntryFormManagement from "./pages/AddEntryFormManagement";
import EditEntryFormManagement from "./pages/EditEntryFormManagement";
import Template from "./pages/Template";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./componets/ProtectedRoute";
import PublicRoute from "./componets/PublicRoute";
import TermsAndConditions from "./pages/TermsAndConditions";
import Policy from "./pages/Policy";
import PricingPlan from "./pages/PricingPlan";
import PricingDetails from "./pages/PricingDetails";
import DeleteAccount from "./pages/DeleteAccount";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
    return (
        <>
            <BrowserRouter>
                <ToastContainer position="top-right" />
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PublicRoute>
                                <Login />
                            </PublicRoute>
                        }
                    />
                    {/* <Route
                        path="/register"
                        element={
                            <PublicRoute>
                                <Register />
                            </PublicRoute>
                        }
                    /> */}
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    {/* <Route
                        path="/forget-password"
                        element={<ForgetPassword />}
                    /> */}
                    {/* <Route
                        path="/verification"
                        element={<TwoFactorVerification />}
                    /> */}
                    {/* <Route
                        path="/create-new-password"
                        element={<CreateNewPassword />}
                    /> */}
                    {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                    <Route path="/category" element={<ProtectedRoute><Category /></ProtectedRoute>} />
                    <Route path="/user" element={<ProtectedRoute><User /></ProtectedRoute>} />
                    <Route
                        path="/entry-form"
                        element={<ProtectedRoute><EntryFormManagement /></ProtectedRoute>}
                    />
                    <Route
                        path="/entry-form-add"
                        element={<ProtectedRoute><AddEntryFormManagement /></ProtectedRoute>}
                    />
                    <Route
                        path="/entry-form-edit"
                        element={<ProtectedRoute><EditEntryFormManagement /></ProtectedRoute>}
                    />
                    <Route path="/template" element={<ProtectedRoute><Template /></ProtectedRoute>} />
                    <Route path="/terms-condition" element={<ProtectedRoute><TermsAndConditions /></ProtectedRoute>} />
                    <Route path="/policy" element={<ProtectedRoute><Policy /></ProtectedRoute>} />
                    <Route path="/pricing" element={<ProtectedRoute><PricingPlan /></ProtectedRoute>} />
                    <Route path="/pricing-details" element={<ProtectedRoute><PricingDetails /></ProtectedRoute>} />
                    <Route path="/delete-account" element={<DeleteAccount />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="*" element={<Login />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
